const carouselItems = [
  {
    title: '娱乐圈税务风暴：多位艺人被约谈内幕',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20scene%20with%20warm%20golden%20light%20breaking%20through%20dark%20shadows%2C%20cinematic%20tension%2C%20mysterious%20atmosphere%2C%20amber%20and%20deep%20charcoal%20contrast%2C%20editorial%20documentary%20style%2C%20high%20drama%20composition%2C%20sophisticated%20visual&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '深度追踪',
    desc: '娱乐圈税务问题持续发酵，调查范围扩大至多位一线艺人，涉及金额或超十亿。',
  },
  {
    title: '网红带货乱象：千万大V售假产业链曝光',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20scene%20with%20warm%20orange%20glow%20and%20deep%20shadows%2C%20cinematic%20documentary%20style%2C%20mysterious%20atmosphere%2C%20golden%20amber%20light%20rays%2C%20editorial%20composition%2C%20high%20contrast%2C%20luxurious%20dark%20mood&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '独家调查',
    desc: '从选品到发货，揭秘头部网红直播带货背后的假货供应链完整运作模式。',
  },
  {
    title: '选秀节目黑幕揭秘：票数造假全流程',
    cover: 'https://readdy.ai/api/search-image?query=Theatrical%20stage%20with%20dramatic%20spotlight%20and%20warm%20golden%20glow%2C%20mysterious%20behind%20the%20scenes%20vibe%2C%20cinematic%20film%20noir%20aesthetic%2C%20amber%20and%20charcoal%20contrast%2C%20editorial%20photography%2C%20sophisticated%20dramatic%20composition&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '重磅实锤',
    desc: '内部工作人员实名曝光选秀节目票数造假完整证据链，节目组连夜回应。',
  },
  {
    title: '知名导演潜规则门：录音文字全曝光',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20with%20dramatic%20warm%20lighting%2C%20golden%20amber%20spotlight%20on%20dark%20background%2C%20film%20noir%20aesthetic%2C%20mysterious%20atmosphere%2C%20editorial%20storytelling%20style%2C%20high%20contrast%2C%20artistic%20composition&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '独家爆料',
    desc: '多位新人演员联合发声，揭露某知名导演利用选角之便实施潜规则的全过程。',
  },
  {
    title: '娱乐圈离婚潮：三对明星夫妻婚变内幕',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20scene%20with%20warm%20golden%20light%20dividing%20darkness%2C%20cinematic%20emotional%20tension%2C%20amber%20and%20deep%20shadow%20contrast%2C%20editorial%20documentary%20style%2C%20sophisticated%20moody%20atmosphere%2C%20artistic%20composition&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '深度解析',
    desc: '近期三对明星夫妻接连爆出婚变消息，背后财产分割与抚养权争夺战。',
  },
  {
    title: '综艺节目剧本门：真人秀到底有多假',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20with%20warm%20dramatic%20lighting%2C%20golden%20amber%20glow%20through%20darkness%2C%20mysterious%20atmosphere%2C%20film%20noir%20aesthetic%2C%20editorial%20photography%20style%2C%20high%20contrast%20composition%2C%20sophisticated%20mood&width=600&height=400&seq=carousel-06&orientation=landscape',
    tag: '幕后揭秘',
    desc: '前综艺编剧匿名爆料真人秀剧本套路，从人设到冲突全是预先设计好的。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-focus-2-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">深度追踪 · 黑料在线精选六大重磅专题</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-background-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} - 黑料在线焦点专题`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}